function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustriesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-building-community"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3333 17.5V11.6667L7.16667 7.5L3 11.6667V17.5H7.16667M11.3333 17.5H7.16667M11.3333 17.5H18V3.33333C18 3.11232 17.9122 2.90036 17.7559 2.74408C17.5996 2.5878 17.3877 2.5 17.1667 2.5H8.83333C8.61232 2.5 8.40036 2.5878 8.24408 2.74408C8.0878 2.90036 8 3.11232 8 3.33333V8.33333M7.16667 17.5V14.1667M11.3333 5.83333V5.84167M14.6667 5.83333V5.84167M14.6667 9.16667V9.175M14.6667 12.5V12.5083",
    stroke: "#667085",
    style: {
      stroke: "#667085",
      stroke: "color(display-p3 0.4009 0.4408 0.5207)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustriesIcon);
export default __webpack_public_path__ + "static/media/IndustriesIcon.79b6e604aee23dd1d5ccd3192e38245d.svg";
export { ForwardRef as ReactComponent };